import React, { useState } from "react";
import { AuthInfo } from "../types/auth";

const emptyAuthInfo: AuthInfo = {
    token: null,
    username: null,
    userType: null,
    organization: null,
}

const authContext = React.createContext({
    authInfo: emptyAuthInfo,
    setAuthInfo: (authInfo: AuthInfo) => {}
});

export function useAuthContext() {
    return React.useContext(authContext);
}

export function useDefaultAuthState(initialAuth?: AuthInfo | null) {
    const [ authInfo, setAuthInfo ] = useState(initialAuth || emptyAuthInfo);

    return { authInfo, setAuthInfo }
}

interface AuthContextProviderProps {
    value?: { authInfo: AuthInfo; setAuthInfo: (authInfo: AuthInfo) => void };
    children: React.ReactNode;
}

export default function AuthContextProvider({ value, children }: AuthContextProviderProps) {
    const defaultValue = {
        authInfo: emptyAuthInfo,
        setAuthInfo: (_authInfo: AuthInfo) => {}
    };

    return (
        <authContext.Provider value={value || defaultValue}>
            {children}
        </authContext.Provider>
    );
}
